import { ChangeSrollCss } from 'helpers/utils';
import { ICompanyAccess } from 'types/Company';

import {
  Box,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

type Props = {
  dataRH: ICompanyAccess[] | undefined;
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const CompanyRHAccess: React.FC<Props> = ({ dataRH }) => {
  if (!dataRH) {
    return null;
  }

  return (
    <Box p={2}>
      <Typography fontWeight={700} fontSize={18} mb={1}>
        Acessos Portal do RH
      </Typography>

      <TableContainer
        sx={{
          ...ChangeSrollCss,
          maxHeight: 250,
          alignSelf: 'flex-start',
        }}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>Nome do colaborador</TableCell>
              <TableCell>E-mail corporativo</TableCell>
              <TableCell>Tipo de acesso</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {dataRH.map((data, index) => {
              return (
                <StyledTableRow key={index}>
                  <TableCell sx={{ paddingY: 1 }}>{data.name}</TableCell>

                  <TableCell sx={{ paddingY: 1 }}>{data.email}</TableCell>

                  <TableCell sx={{ paddingY: 1 }}>
                    {data.isSuperUser ? 'Super usuário' : 'Comum'}
                  </TableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
